<template>
    <div class="flex mr-4 gap-4 items-center text-neutral-500 nadia-chat rounded-full w-full px-4 py-4 h-16" data-testid="chat-waiting-message">
        <CoachingModeMarble :is-loading="true" class="-ml-4 max-w-12" />
        <div class="relative flex-1">
            <div class="relative h-8 flex items-center gap-2">
                <div class="relative flex-1 h-8 overflow-hidden">
                    <TransitionGroup name="message-fade">
                        <p v-for="(msg, index) in [currentMessage]" :key="`${index}-${msg}`" class="absolute top-0 left-0 right-0 line-clamp-2" role="status">
                            {{ msg }}
                        </p>
                    </TransitionGroup>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import { onMounted, onUnmounted, ref } from "vue";

const props = defineProps({
    messages: {
        type: Array,
        default: () => [],
    },
    rotationInterval: {
        type: Number,
        default: 3000, // 3 seconds per message
    },
});

const currentMessage = ref("");
const rotationTimer = ref(null);

const getRandomMessage = () => {
    if (props.messages.length === 0) {
        return "";
    }
    const randomIndex = Math.floor(Math.random() * props.messages.length);
    return props.messages[randomIndex];
};

const rotateMessage = () => {
    currentMessage.value = getRandomMessage();
};

onMounted(() => {
    // Set initial message
    currentMessage.value = getRandomMessage();

    // Start rotation if we have messages to rotate
    if (props.messages.length > 1) {
        rotationTimer.value = setInterval(rotateMessage, props.rotationInterval);
    }
});

onUnmounted(() => {
    if (rotationTimer.value) {
        clearInterval(rotationTimer.value);
    }
});
</script>

<style scoped>
.message-fade-enter-active {
    transition: opacity 400ms ease-in-out;
}

.message-fade-leave-active {
    transition: opacity 400ms ease-in-out;
}

.message-fade-enter-from {
    opacity: 0;
}

.message-fade-leave-to {
    opacity: 0;
}
</style>
